import { MOBILE_BREAKPOINT, NAV_ADMIN_SUITE_HEIGHT, NAV_ADMIN_SUITE_SECONDARY_HEIGHT, NAV_PRIMARY_HEIGHT, NAV_PRIMARY_MOBILE_HEIGHT, NAV_SECONDARY_HEIGHT, NAV_SECONDARY_MOBILE_HEIGHT, NAV_SECONDARY_TOP_PADDING } from "./constants";
export const navHeight = ({ priority, shouldHavePadding = false }) => {
    if (priority === "secondary") {
        const padding = shouldHavePadding ? NAV_SECONDARY_TOP_PADDING : 0;
        return `
      height: ${NAV_SECONDARY_MOBILE_HEIGHT}px;

      @media (min-width: ${MOBILE_BREAKPOINT}px) {
        height: ${NAV_SECONDARY_HEIGHT}px;
        padding-top: ${padding}px;
      }
    `;
    }
    if (priority === "adminPrimary") {
        return `
      height: ${NAV_ADMIN_SUITE_HEIGHT}px;

      @media (min-width: ${MOBILE_BREAKPOINT}px) {
        height: ${NAV_ADMIN_SUITE_HEIGHT}px;
      }
    `;
    }
    if (priority === "adminSecondary") {
        return `
      height: ${NAV_ADMIN_SUITE_SECONDARY_HEIGHT}px;

      @media (min-width: ${MOBILE_BREAKPOINT}px) {
        height: ${NAV_ADMIN_SUITE_SECONDARY_HEIGHT}px;
      }
    `;
    }
    return `
    height: ${NAV_PRIMARY_MOBILE_HEIGHT}px;

    @media (min-width: ${MOBILE_BREAKPOINT}px) {
      height: ${NAV_PRIMARY_HEIGHT}px;
    }
  `;
};
